import { useQuery } from "@tanstack/react-query";
import { journalsQueries } from "@/entities/journal";
import { useCoordinator } from "@/shared/lib/hooks";
import { getJournalIntegrationTagKind } from "./get-journal-integration-tag";
import type { GsnIntegrationSettings } from "./types";

export const useJournalIntegrationTag = () => {
  const { titleId, objectId } = useCoordinator();

  const { data: journalTitle } = useQuery({
    ...journalsQueries.getTitleJournal({ titleId }),
    enabled: !!titleId,
  });

  const { data: journalsData, isSuccess: isSettingsLoaded } = useQuery({
    ...journalsQueries.getDraftJournals({
      buildingObjectId: objectId,
      page: 1,
      limit: 100,
    }),
    enabled: !!objectId,
  });

  const titleStatus = journalTitle?.mainJournal?.titleJournal?.status;
  const settings = journalsData?.buildingObject
    ?.gsnIntegrationSettings as GsnIntegrationSettings | undefined;

  const kind = getJournalIntegrationTagKind({
    titleStatus,
    settings,
    isSettingsLoaded: isSettingsLoaded || !objectId,
  });

  return { kind };
};
